module.exports = __webpack_public_path__ + "img/514-2a64d5.png";